import {Drawer} from "@mui/material";
import React from "react";

export default function StaffInvoicesDetailsBoxNew({row,isOpen,setIsOpen}) {

    if(!row || row.length === 0) return null;
    return (
        <Drawer open={isOpen} onClose={() => setIsOpen(false)} anchor={"right"} >
            <div style={{width:550, padding:20, fontSize:'0.7em'}}>
                <pre>{JSON.stringify(row,null,2)}</pre>
            </div>
        </Drawer>
    )
}
